<template>
  <div class="statistics">
    <div style="padding: 0px 20px;height: 100%">
      <div class="search">
        <div v-for="item in search" :class='["search_options_box"]'>
          <span style="width: 100px;">{{item.title}}</span>
<!--          <img src="/static/img/select.png" alt="">-->
          <el-select class="select" v-model="selectValue" placeholder="请选择项目" @change="getPieList(),getEnergyList()">
            <el-option v-for="item2 in item.options" :label="item2.label" :value="item2.value" :key="item2.value"></el-option>
          </el-select>
        </div>
      </div>
      <div :class='["information_box","light_border"]'
           :style="[{width:'25%'},{'min-height':'350px'},{height:'36.5%'}]">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <div class="nva_btn">
            <button class="income_btn focus">亮灯率</button>
          </div>
          <div id="LightRate"></div>
        </div>
      </div>

      <div :class='["information_box","light_border"]'
           :style="[{width:'25%'},{'margin-left':'calc(1.25% - 3px)'},{'min-height':'350px'},{height:'36.5%'}]">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <div class="nva_btn">
            <button class="income_btn focus">故障率</button>
          </div>
          <div id="FaultRate"></div>
        </div>
      </div>

      <div :class='["information_box","light_border"]'
           :style="[{width:'47.5%'},{'margin-left':'calc(1.25% - 3px)'},{'min-height':'350px'},{height:'36.5%'}]">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <div class="nva_btn">
            <button class="income_btn focus">能耗分析</button>
          </div>
          <div id="ECA"></div>
        </div>
      </div>

      <div :class='["information_box","light_border"]'
           :style="[{width:'100%'},{'min-height':'350px'},{height:'36.5%'}]">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <div class="nva_btn">
            <button @click="income_day()" class="income_btn focus">设备列表</button>
          </div>
          <div id="equipment">
            <table class="EmergencyTable">
              <thead>
              <tr>
                <th>灯杆编号</th>
                <th width="160px;">地理位置</th>
                <th>时间段</th>
                <th>17:00</th>
                <th>18:00</th>
                <th>19:00</th>
                <th>20:00</th>
                <th>21:00</th>
                <th>22:00</th>
                <th>23:00</th>
                <th>00:00</th>
                <th>01:00</th>
                <th>02:00</th>
                <th>03:00</th>
                <th>04:00</th>
                <th>05:00</th>
                <th>06:00</th>
                <th>07:00</th>
                <th>08:00</th>
                <th>亮度</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in tabledata">
                <td>{{item.lamppost_id}}</td>
                <td style="width: 160px;">{{item.site}}</td>
                <td>{{item.time_quantum}}</td>
                <td>
                  <div :style="0<=item.end_hour&&0>=item.start_hour?[{'background':color[index%3]}]:[]" style="height: 25px;">
                    <span v-if="item.start_hour.toString()==='0'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="1<=item.end_hour&&1>=item.start_hour?[{'background':color[index%3]}]:[]" style="height: 25px;">
                    <span v-if="item.start_hour.toString()==='1'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="2<=item.end_hour&&2>=item.start_hour?[{'background':color[index%3]}]:[]" style="height: 25px;">
                    <span v-if="item.start_hour.toString()==='2'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="3<=item.end_hour&&3>=item.start_hour?[{'background':color[index%3]}]:[]" style="height: 25px;">
                    <span v-if="item.start_hour.toString()==='3'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="4<=item.end_hour&&4>=item.start_hour?[{'background':color[index%3]}]:[]" style="height: 25px;">
                    <span v-if="item.start_hour.toString()==='4'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="5<=item.end_hour&&5>=item.start_hour?[{'background':color[index%3]}]:[]" style="height: 25px;">
                    <span v-if="item.start_hour.toString()==='5'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="6<=item.end_hour&&6>=item.start_hour?[{'background':color[index%3]}]:[]" style="height: 25px;">
                    <span v-if="item.start_hour.toString()==='6'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="7<=item.end_hour&&7>=item.start_hour?[{'background':color[index%3]}]:[]" style="height: 25px;">
                    <span v-if="item.start_hour.toString()==='7'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="8<=item.end_hour&&8>=item.start_hour?[{'background':color[index%3]}]:[]" style="height: 25px;">
                    <span v-if="item.start_hour.toString()==='8'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="9<=item.end_hour&&9>=item.start_hour?[{'background':color[index%3]}]:[]" style="height: 25px;">
                    <span v-if="item.start_hour.toString()==='9'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="10<=item.end_hour&&10>=item.start_hour?[{'background':color[index%3]}]:[]" style="height: 25px;">
                    <span v-if="item.start_hour.toString()==='10'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="11<=item.end_hour&&11>=item.start_hour?[{'background':color[index%3]}]:[]" style="height: 25px;">
                    <span v-if="item.start_hour.toString()==='11'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="12<=item.end_hour&&12>=item.start_hour?[{'background':color[index%3]}]:[]" style="height: 25px;">
                    <span v-if="item.start_hour.toString()==='12'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="13<=item.end_hour&&13>=item.start_hour?[{'background':color[index%3]}]:[]" style="height: 25px;">
                    <span v-if="item.start_hour.toString()==='13'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="14<=item.end_hour&&14>=item.start_hour?[{'background':color[index%3]}]:[]" style="height: 25px;">
                    <span v-if="item.start_hour.toString()==='14'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="15<=item.end_hour&&15>=item.start_hour?[{'background':color[index%3]}]:[]" style="height: 25px;">
                    <span v-if="item.start_hour.toString()==='15'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>{{item.brightness}}</td>
              </tr>
              <tr v-if="this.tabledataNull">
                <td>暂无数据</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>


  </div>
</template>

<script>
  //引入echarts
  let echarts = require('echarts/lib/echarts');
  // 引入柱状图组件
  require('echarts/lib/chart/bar');
  require('echarts/lib/chart/line');
  require('echarts/lib/chart/scatter');
  require('echarts/lib/chart/pie');
  require('echarts/lib/chart/effectScatter');
  // 引入提示框和title组件
  require('echarts/lib/component/tooltip');
  require('echarts/lib/component/title');
  require('echarts/lib/component/legend');
  require('echarts/lib/component/geo');


  export default {
    name: "statistics",
    data() {
      return {
        search: [
          {
            title: '选择项目',
            options: [],
          },
        ],
        selectValue:'17e3b71e-b460-498e-b0ef-657d20bd6549',
        projectList:[],
        tabledata: [],
        color: [],
        tabledataNull:false,
        //缓存数组
        Light_Rate: [
          {value: 0,name: '正常使用中'},
          {value: 0,name: '设备未启用'}
        ],
        Failure_Rate: [
          {value: 0,name: '正常使用中'},
          {value: 0,name: '设备故障'}
        ],
        ECA_Data:[],
        //

      }
    },
    mounted() {
      //初始化表格
      this.Light_rate();
      this.Fault_Rate();
      let color = ["#f87544", "#25d053", "#7a7bfe"];
      // let colorAarry = []
      // for (let i = 0; i < 10000; i++) {
      //   let ColorRandom = color[Math.floor(Math.random() * color.length)];
      //   colorAarry.push(ColorRandom);
      // }
      this.color = color;
      fetch('/api/v1/lamp/task/list', {
        method: 'post',
      })
        .then(result => {
          console.log(result)
          return result.json();//解析流
        })
        .then(data => {
          this.tabledata = data.data;
        })
        .catch((error) => {
          this.tabledataNull = true;
          throw  error
        });


    },
    created() {
      this.getEnergyList();
      this.InitLeftMenu();
      this.getPieList();
      this.getProjectList();
    },
    methods: {
      InitLeftMenu: function () {
        this.$emit('getMessage', '0', '0');
      },
      getPieList:function(){
        //亮灯率
        fetch('/api/v1/statistics/lamp', {
          method: 'post',
          body: JSON.stringify({
            "project_id":this.selectValue,
          })
        })
          .then(result => {
            console.log(result)
            return result.json();//解析流
          })
          .then(data => {
            this.Light_Rate[0].value = data.data.open_count;
            this.Light_Rate[1].value=data.data.total_count-data.data.open_count;
            this.Failure_Rate[1].value = data.data.fault_count;
            this.Failure_Rate[0].value=data.data.total_count-data.data.fault_count;
            this.Light_rate();
            this.Fault_Rate();

          })
          .catch((error) => {
            this.tabledataNull = true;
            throw  error
          });
      },
      Light_rate: function () {
        // var Light_Rate = this.Light_Rate;
        let myChart1 = echarts.init(document.getElementById('LightRate'));
        myChart1.setOption({
          tooltip: {
            trigger: 'item',
            formatter: "{b} : {c} ({d}%)"
          },
          series: [{
            name: '亮灯率',
            type: 'pie',
            radius: '70%',
            center: ['50%', '50%'],
            color: [ '#FBFE27', 'rgb(131,249,103)'], //'#FBFE27','rgb(11,228,96)','#FE5050'
            data: this.Light_Rate,
            //   .sort(function(a, b) {
            //   return a.value - b.value
            // }),
            roseType: 'radius',

            label: {
              normal: {
                formatter: ['{c|{d}%}', '{b|{b}}'].join('\n'),
                rich: {
                  c: {
                    color: '#ffffff',
                    fontSize: 20,
                    fontWeight:'bold',
                    lineHeight: 5
                  },
                  b: {
                    color: 'rgb(98,137,169)',
                    fontSize: 15,
                    height: 40
                  },
                },
              }
            },
            labelLine: {
              normal: {
                lineStyle: {
                  color: 'rgb(98,137,169)',
                },
                smooth: 0.2,
                length: 10,
                length2: 20,

              }
            },
            itemStyle: {
              normal: {
                shadowColor: 'rgba(0, 0, 0, 0.8)',
                shadowBlur: 50,
              }
            }
          }]
        });
        window.onresize = function () {
          myChart1.resize();
        };
      },

      Fault_Rate: function () {
        // var Fault_Rate = this.Failure_Rate;
        let myChart2 = echarts.init(document.getElementById('FaultRate'));
        myChart2.setOption({
          tooltip: {
            trigger: 'item',
            formatter: "{b} : {c} ({d}%)"
          },
          series: [{
            name: '故障率',
            type: 'pie',
            radius: '70%',
            center: ['50%', '50%'],
            color: ['#1DB7E5','#FE5050' ], //'#FBFE27','rgb(11,228,96)','#FE5050'
            data: this.Failure_Rate,
            //   .sort(function(a, b) {
            //   return a.value - b.value
            // }),
            roseType: 'radius',

            label: {
              normal: {
                formatter: ['{c|{d}%}', '{b|{b}}'].join('\n'),
                rich: {
                  c: {
                    color: '#ffffff',
                    fontSize: 20,
                    fontWeight:'bold',
                    lineHeight: 5
                  },
                  b: {
                    color: 'rgb(98,137,169)',
                    fontSize: 15,
                    height: 40
                  },
                },
              }
            },
            labelLine: {
              normal: {
                lineStyle: {
                  color: 'rgb(98,137,169)',
                },
                smooth: 0.2,
                length: 10,
                length2: 20,

              }
            },
            itemStyle: {
              normal: {
                shadowColor: 'rgba(0, 0, 0, 0.8)',
                shadowBlur: 50,
              }
            }
          }]
        });
        window.onresize = function () {
          myChart2.resize();
        };
      },

      getEnergyList:function(){
        //获取灯的能耗
        fetch("/api/v1/statistics/lamp/energyConsumption", {
          method: 'post',
          body: JSON.stringify({
            project_id:this.selectValue,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "能耗数据更新成功";
              this.refresh = true;
              this.msg_show = !this.msg_show;
              this.ECA_Data = data.data;
              this.ECA();
              //this.Switch = data.data.lamp.status;
            } else {
              this.message = "数据更新异常，请重试";
              this.msg_show = !this.msg_show;
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },


      //获取项目搜索
      getSelectProject:function(){

      },


      //获取项目列表
      getProjectList:function(){
        fetch("/api/v1/project/list", {
          method: 'post',
          body: JSON.stringify({

          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "项目数据获取成功";
              this.projectList = data.data;
              let options = this.search[0].options;
              for (let i=0;i<this.projectList.length;i++){
                let projectObj = {};
                projectObj.label = this.projectList[i].name;
                projectObj.value = this.projectList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },


      ECA:function () {
        let date = [];
        let data = [];
        for (let i = 0; i < this.ECA_Data.length; i++) {
          date.push(this.ECA_Data[i].date);
          data.push(this.ECA_Data[i].cumulative_power);
        };
        let myChart3 = echarts.init(document.getElementById('ECA'));
        myChart3.setOption({
          grid: {
            top: '20%',
            right: '60px',
            left: '60px',
            bottom: '15%'
          },
          xAxis: [{
            type: 'category',
            data:date,
            axisLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.12)'
              }
            },
            axisLabel: {
              margin: 10,
              color: '#e2e9ff',
              textStyle: {
                fontSize: 14
              },
            },
          }],
          yAxis: [{
            name:"单位（kw）",
            type: "value",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 14,
              align: "left",
            },
            axisLabel: {
              formatter: '{value}',
              color: '#e2e9ff',
            },
            axisLine: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.12)'
              }
            }
          }],
          series: [{
            type: 'bar',
            data: data,
            barWidth: '20px',
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(0,244,255,1)' // 0% 处的颜色
                }, {
                  offset: 1,
                  color: 'rgba(0,77,167,1)' // 100% 处的颜色
                }], false),
                barBorderRadius: [30, 30, 30, 30],
                shadowColor: 'rgba(0,160,221,1)',
                shadowBlur: 4,
              }
            },
            label: {
              normal: {
                show: true,
                lineHeight: 30,
                width: 80,
                height: 30,
                backgroundColor: 'rgba(0,160,221,0.1)',
                borderRadius: 200,
                position: ['-8', '-60'],
                distance: 1,
                formatter: [
                  '    {d|●}',
                  ' {a|{c}kw}     \n',
                  '    {b|}'
                ].join(','),
                rich: {
                  d: {
                    color: '#3CDDCF',
                  },
                  a: {
                    color: '#fff',
                    align: 'center',
                  },
                  b: {
                    width: 1,
                    height: 30,
                    borderWidth: 1,
                    borderColor: '#234e6c',
                    align: 'left'
                  },
                }
              }
            }
          }]
        });
        window.onresize = function () {
          myChart3.resize();
        };
      }
    },

  }
</script>

<style scoped>
  .statistics {
    width: 100%;
    height: 100%;
  }

  .search {
    width: 100%;
    height: 76px;
    padding: 0;
  }

  .search_options_box {
    width: 275px;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #5a7595;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 36px;
    right: 20px;
    cursor: pointer;
  }

  .statistical_overview {
    width: 100%;
    height: 120px;
    display: flex;
    justify-content: space-between;
  }

  .statistical_box {
    width: calc(20% - 16px);
    height: 100%;
    background-color: #0b2f54;
    border-radius: 6px;
    border: 1px solid #5a7192;
    -webkit-box-shadow: 0 0 10px #16518d inset;
    box-shadow: 0 0 10px #16518d inset;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .statistical_box > div:nth-child(1) {
    width: 80px;
    height: 80px;
    margin: 0 20px;
  }

  .statistical_box > div:nth-child(2) {
    font-size: 20px;
    font-weight: bold;
  }

  .nva_btn {
    padding: 20px;
  }
  .information_content>div:nth-child(2){
    width: 100%;
    height: calc(100% - 67px);
  }
  .income_btn {
    background: transparent;
    font-size: 16px;
    border: transparent;
    outline: transparent;
    color: #95bee5;
    margin-right: 20px;
  }

  .focus {
    font-size: 18px;
    color: #00f0ff;
  }

  #equipment {
    padding: 0 20px;
    box-sizing: border-box;
    height: calc(100% - 87px);
  }

  #equipment table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
  }

  #equipment table thead tr {
    height: 40px;
    border-bottom: 1px solid #094b8e;
  }

  #equipment table thead tr th {
    color: #FFFFFF;
    font-size: 16px;
  }

  #equipment table tbody {
    display: block;
    height: 100%;
    overflow-y: scroll;
  }

  #equipment table thead tr,
  #equipment table tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    text-align: center;
  }

  #equipment table tbody tr {
    background: #16518d;
  }

  #equipment table tbody tr:nth-child(2n+0) {
    background: #11406f;
  }

  #equipment table tbody tr td {
    height: 40px;
    width: auto;
    color: #FFFFFF;
    border-bottom: 3px solid transparent;
    border-top: 3px solid transparent;
  }
  #equipment table tbody tr td div{
    width: 100%;
    height: 30px;
    line-height: 30px;
  }
  #equipment table thead {
    width: calc(100% - 1em);
  }


</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/1_lamp/statistics.vue